import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

import aws from "../../static/images/products/aws.svg";
import azure from "../../static/images/products/azure.svg";
import devops1 from "../../static/images/products/devops1.svg";
import devops2 from "../../static/images/products/devops2.svg";
import devops3 from "../../static/images/products/devops3.svg";
import docker from "../../static/images/products/docker.svg";
import devops4 from "../../static/images/products/devops4.svg";
import hashicorp from "../../static/images/products/hashicorp.svg";

import '../styles/style.scss';

class DevOpsProducts extends Component {
  render() {
    return(
      <div>
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={12} lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={aws} alt="aws" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col xs={12} lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={azure} alt="azure" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col xs={12} lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={devops1} alt="devops1" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col xs={12} lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={devops2} alt="devops2" className="product-image smaller-desktop"/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={devops3} alt="devops3" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={hashicorp} alt="hashicorp" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={docker} alt="docker" className="product-image smaller-desktop"/>
                </div>
              </Col>
              <Col lg={3} className="mb-5">
                <div className="technology-box">
                  <img src={devops4} alt="devops4" className="product-image smaller-desktop"/>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default (DevOpsProducts);